export default __webpack_public_path__ + "static/1272-8c45d7fab77f7913167657954a6fc312.png";